import { HttpClient } from '@angular/common/http';
import { Component, inject, type OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import type {
  ReqBody,
  ResBody,
} from '../../../server/routes/auth/request-password-reset';
import { HomepageLinksService } from '../homepage-links.service';
import { TitleService } from '../title.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: false,
})
export class ForgotPasswordComponent implements OnInit {
  private http = inject(HttpClient);
  private titleService = inject(TitleService);
  public homepageLinks = inject(HomepageLinksService);

  form = new FormGroup({
    email: new FormControl('', {
      validators: [Validators.required, Validators.email],
      nonNullable: true,
    }),
  });
  submitSuccess = false;
  waiting = false;
  formErrorMessage: string | undefined;

  ngOnInit() {
    this.titleService.set('Forgot password');
  }

  submit(formData) {
    if (this.form.invalid) {
      return;
    }
    // Clear state from previous submissions
    this.formErrorMessage = undefined;

    this.waiting = true;
    const body: ReqBody = { email: formData.email };
    this.http
      .post<ResBody>('/api/auth/request-password-reset', body)
      .subscribe({
        next: () => {
          this.waiting = false;
          this.submitSuccess = true;
        },
        error: () => {
          this.waiting = false;
          this.formErrorMessage = 'There was a problem submitting the form.';
        },
      });
  }
}
